'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnnouncementBar = function AnnouncementBar(el) {
  (0, _classCallCheck3.default)(this, AnnouncementBar);

  // Get header height and adjust padding of page content
  var setPadding = function setPadding() {
    var lytSite = document.getElementById('MainContent');
    var hdHeight = document.querySelector('.hd-Header').offsetHeight;
    lytSite.style.paddingTop = hdHeight + 'px';
  };

  // Get header height and update black mobile nav position
  var setHeaderTransform = function setHeaderTransform() {
    var hd = document.querySelector('.hd-Header');
    var hdHeight = document.querySelector('.hd-Header').offsetHeight;
    if (window.innerWidth <= _utils.mediaBreakpoints.sm) {
      if (hd.classList.contains('hd-Header_AnnouncementActive')) {
        window.onscroll = function (e) {
          if (hd.classList.contains('js-Header-fixed')) {
            hd.style.transform = 'translateY(-' + (hdHeight + 'px') + ')';
          } else {
            hd.style.transform = 'none';
          }
        };
      }
    } else {
      if (hd.classList.contains('hd-Header_AnnouncementActive')) {
        hd.style.transform = null;
      }
    }
  };

  setPadding();
  setHeaderTransform();

  window.onresize = function (event) {
    setPadding();
    setHeaderTransform();
  };
};

exports.default = AnnouncementBar;